import type { FC } from "react";
import { useLogoutLoading } from "../../contexts/logout-loading-context";

const LogoutLoading: FC = () => {
	const { isLoggingOut } = useLogoutLoading();

	if (!isLoggingOut) {
		return null;
	}

	return (
		<div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white">
			<div className="flex items-center gap-1 text-[var(--c-gray-900)] text-xl">
				<span>Logging out</span>
				<span className="animate-dot-blink opacity-0">.</span>
				<span className="animate-dot-blink opacity-0 [animation-delay:0.5s]">
					.
				</span>
				<span className="animate-dot-blink opacity-0 [animation-delay:1s]">
					.
				</span>
			</div>
		</div>
	);
};

export { LogoutLoading };
